<template>
  <MaskLayer v-if="isOpen">
      <PopupFrame :class="{'te-alert-lg': isLarge}" :display="chooseMode" :cancelWording="cancelWording" :confirmWording="confirmWording" :isCustomize="isCustomize" @close="close" @confirm="confirm">
        <h5 class="alert-heading">{{ title }}</h5>
        <p class="text-break-word font-size-md" v-html="content"></p>
      </PopupFrame>
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer.vue';
import PopupFrame from '@/components/PopupFrame.vue';

export default {
  components: {
    MaskLayer,
    PopupFrame,
  },
  props: {
    // 是否開啟 Popup
    isOpen: {
      type: Boolean,
      default: false,
    },
    // 是否為大型 Popup
    isLarge: {
      type: Boolean,
      default: false,
    },
    // 標題
    title: {
      type: String,
      default: '',
    },
    // 內容
    content: {
      type: String,
      required: true,
    },
    // 顯示模式 詳細請參考displayMode
    mode: {
      type: String,
      default() {
        return 'default';
      },
    },
    // 取消按鈕文案
    cancelWording: {
      type: String,
      default() {
        return this.$t('global.cancel');
      },
    },
    // 確認按鈕文案
    confirmWording: {
      type: String,
      default() {
        return this.$t('global.confirm');
      },
    },
    // 是否客製按鈕
    isCustomize: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 顯示模式
      displayMode: [
        {
          type: 'hintwithclose',
          close: true,
          cancel: false,
          confirm: true,
        },
        {
          type: 'hint',
          close: false,
          cancel: false,
          confirm: true,
        },
        {
          type: 'default',
          close: true,
          cancel: true,
          confirm: true,
        },
      ],
    };
  },
  methods: {
    // 關閉
    close() {
      this.$emit('update:isOpen', false);
    },
    // 確認 (在 PopupFrame 傳出事件前已有呼叫關閉事件)
    confirm() {
      this.$emit('confirm');
    },
  },
  computed: {
    chooseMode() {
      return this.displayMode.find((x) => x.type === this.mode);
    },
  },
};
</script>
